var $38c1f6a6732c7a56$exports = {};
$38c1f6a6732c7a56$exports = {
    "valid": `Gyldig`
};


export {$38c1f6a6732c7a56$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
